import Vue from 'vue'
import App from './App.vue'

import router from './router'

import './assets/css/reset.css'
import './assets/css/common.less'
import './assets/css/fonts.css'
import './assets/css/font.css'

import 'vant/lib/index.css'
import './util/resizeRem' // 重置post
import './util/FastClick'

import store from './store'
import global from './common/global' // 全局变量
import components from './components/default' // 全局组件
import plugins from './plugin/index' // 全局插件 如果有很常用的就在webpackPlugin
import './router/permission' // permission control
import apiList from './services/index'

// import Vconsole from 'vconsole'
// if (process.env.NODE_ENV === 'development') {
//   console.log('process.env.ENV_NAME')
//   const vc = new Vconsole()
//   Vue.use(vc)
// }
// import filters from './util/filter'

// 引入全局组件
// console.log(components,'components')
components.forEach(component => {
  if (component && component.name) {
    Vue.component(component.name, component)
  }
})

// 引入全局插件
plugins.forEach(plugin => {
  if (plugin) {
    Vue.use(plugin)
  }
})

Vue.prototype.global = global
Vue.prototype.$api = apiList

// Vue.prototype.

// // 注入全局过滤器
// Object.keys(filters).forEach(item => {
//   Vue.filter(item, filters[item])
// })

export default new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
